import { POPUP } from 'utils/constants/popup';
import { AssistanceChatPopup } from 'chat/AssistanceChatPopup/AssistanceChatPopup';
import { NbaChatPopup } from 'chat/NbaChatPopup/NbaChatPopup';
import { ChatUploadPopup } from 'chat/ChatUploadPopup/ChatUploadPopup';
import { UploadExplainChat } from 'chat/UploadExplainChat/UploadExplainChat';
import NextScan from './NextScan';
import ChangeLocation from './ChangeLocation';
import { MedicalProfile } from './MedicalProfile/MedicalProfile';
import Questionnaire from './Questionnaire';
import Questions from './Questions';
import UserIntent from './UserIntent';
import HasAnythingChanged from './HasAnythingChanged';
import NextAppointment from './NextAppointment';
import AddDoctor from './AddDoctor';
import SearchDoctor from './SearchDoctor';
import ConsultWithUs from './ConsultWithUs';
import { ShareWithMyDoctor } from './ShareWithDoctor/ShareWithMyDoctor';
import { HCPShareWithDoctor } from './ShareWithDoctor/HCPShareWithDoctor';
import SendToDoctor from './SendToDoctor/SendToDoctor';
import TreatmentSurvey from './TreatmentSurvey';
import TravelingPreferences from './TravelingPreferences';
import SeeAllOptions from './SeeAllOptions';
import ConnectWithOncologist from './ConnectWithOncologist';
import MissingCriticalInformation from './MissingCriticalInformation';
import DebugPopup from './Debug';
import ContactUs from './ContactUs';
import GeneralPopup from './General';
import PreferenceCategory from './PreferenceCategory';
import PhoneNumber from './PhoneNumber';
import CallUs from './CallUs';
import UnsubscribeForm from './UnsubscribeForm';
import BiomarkersPopup from './Biomarkers';
import IntakePopup from './Intake';
import { AboutYouPopup } from './AboutYou';
import { UploadPopup } from './Upload/UploadPopup';
import { CurrentUserUploadPopup } from './Upload/CurrentUserUploadPopup';
import { AddHCPPatient } from './AddHCPPatient';
import { UserSignup } from './UserSignup';
import { HCPUserSignup } from './HCPSignup/HCPUserSignup';
import { HCPPatientSignup } from './HCPSignup/HCPPatientSignup';
import AiAssistantPopup from './AiAssistant';
import EditQuestion from './EditQuestion';
import { PhoneIsAlreadyUsed } from './PhoneIsAlreadyUsed/PhoneIsAlreadyUsed';
import { GetInTouch } from './GetInTouch/GetInTouch';
import { IntakeOnboarding } from './IntakeOnboarding/IntakeOnboarding';

export const V1_POPUP_VERSION = 'v1';
export const V2_POPUP_VERSION = 'v2';
export const V3_POPUP_VERSION = 'v3';

export const POPUP_COMPONENT_BY_POPUP = {
  [POPUP.NEXT_SCAN]: NextScan,
  [POPUP.CHANGE_LOCATION]: ChangeLocation,
  [POPUP.MEDICAL_PROFILE]: MedicalProfile,
  [POPUP.QUESTIONNAIRE]: Questionnaire,
  [POPUP.QUESTIONS]: Questions,
  [POPUP.USER_INTENT]: UserIntent,
  [POPUP.HAS_ANYTHING_CHANGED]: HasAnythingChanged,
  [POPUP.NEXT_APPOINTMENT]: NextAppointment,
  [POPUP.ADD_DOCTOR]: AddDoctor,
  [POPUP.SEARCH_DOCTOR]: SearchDoctor,
  [POPUP.CONSULT_WITH_US]: ConsultWithUs,
  [POPUP.SHARE_WITH_MY_DOCTOR]: ShareWithMyDoctor,
  [POPUP.HCP_SHARE_WITH_DOCTOR]: HCPShareWithDoctor,
  [POPUP.SEND_TO_DOCTOR]: SendToDoctor,
  [POPUP.TREATMENT_SURVEY]: TreatmentSurvey,
  [POPUP.TRAVELING_PREFERENCES]: TravelingPreferences,
  [POPUP.SEE_ALL_OPTIONS]: SeeAllOptions,
  [POPUP.CONNECT_WITH_ONCOLOGIST]: ConnectWithOncologist,
  [POPUP.MISSING_CRITICAL_INFORMATION]: MissingCriticalInformation,
  [POPUP.DEBUG]: DebugPopup,
  [POPUP.CONTACT_US]: ContactUs,
  [POPUP.GENERAL]: GeneralPopup,
  [POPUP.PREFERENCE_CATEGORY]: PreferenceCategory,
  [POPUP.PHONE_NUMBER]: PhoneNumber,
  [POPUP.CALLUS]: CallUs,
  [POPUP.UNSUBSCRIBE_FORM]: UnsubscribeForm,
  [POPUP.BIOMARKERS]: BiomarkersPopup,
  // can be used something like /dashboard/results?popup=intake
  [POPUP.INTAKE]: IntakePopup,
  [POPUP.ABOUT_YOU]: AboutYouPopup,
  [POPUP.ASSISTANCE_CHAT]: AssistanceChatPopup,
  [POPUP.NBA_CHAT]: NbaChatPopup,
  [POPUP.CHAT_UPLOAD]: ChatUploadPopup,
  [POPUP.CHAT_UPLOAD_EXPLAIN]: UploadExplainChat,
  [POPUP.UPLOAD]: UploadPopup,
  [POPUP.CURRENT_USER_UPLOAD]: CurrentUserUploadPopup,
  [POPUP.ADD_HCP_PATIENT]: AddHCPPatient,
  [POPUP.USER_SIGNUP]: UserSignup,
  [POPUP.HCP_USER_SIGNUP]: HCPUserSignup,
  [POPUP.HCP_PATIENT_SIGNUP]: HCPPatientSignup,
  [POPUP.AI_ASSISTANT]: AiAssistantPopup,
  [POPUP.EDIT_QUESTION]: EditQuestion,
  [POPUP.PHONE_IS_ALREADY_USED]: PhoneIsAlreadyUsed,
  [POPUP.GET_IN_TOUCH]: GetInTouch,
  [POPUP.INTAKE_ONBOARDING]: IntakeOnboarding,
};
